// extracted by mini-css-extract-plugin
export default {"page":"styles_page__yvOGb","title":"styles_title__TU+px","subtitle":"styles_subtitle__KbQjx","table":"styles_table__Uxllr"};